import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Typography, Box, Chip } from "@mui/material";
import { dashboardPalette } from "../theme";
import useCurrentUserData from "../hooks/useCurrentUserData";
import { renderLooseNode } from "../utils/rewards";

const LogrosCarousel: React.FC = () => {
  const { userData } = useCurrentUserData();
  const achievements = userData?.Logros ?? [];

  return (
    <Slider
      dots={false}
      infinite={true}
      slidesToShow={5}
      slidesToScroll={1}
      vertical={true}
      verticalSwiping={true}
      speed={1000}
      autoplaySpeed={5000}
      autoplay={false}
    >
      {achievements.map((ach, index) => {
        return (
          <div key={index}>
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 2,
                borderRadius: "16px",
                background:
                  ach.Status == "Completado"
                    ? "rgba(79, 194, 134, 0.15)"
                    : "#fff",
                border:
                  ach.Status == "Completado"
                    ? "1px solid rgba(79, 194, 134, 0.5)"
                    : `1px solid ${dashboardPalette.panelBorder}`,
                opacity: ach.Status == "Completado" ? 1 : 0.6,
              }}
            >
              <Typography sx={{ fontSize: "32px", mr: 2 }}>
                {renderLooseNode(ach.Icon, "🏅")}
              </Typography>
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="h6"
                  sx={{ color: "#2d1b69", fontWeight: 700 }}
                >
                  {ach.Name}
                </Typography>
                <Typography variant="body2" sx={{ color: "#2d1b69" }}>
                  {ach.Description}
                </Typography>
              </Box>
              {ach.Status == "Completado" && (
                <Chip
                  label="Completado"
                  size="small"
                  sx={{
                    background: "var(--dashboard-teal)",
                    color: "#fff",
                    fontWeight: 600,
                  }}
                />
              )}
            </Box>
          </div>
        );
      })}
    </Slider>
  );
};

export default LogrosCarousel;
